<template>
    <router-link
        class="hover:bg-muval-gray-6 focus:ring-muval-brand flex h-16 w-full items-center gap-x-4 rounded-md p-2 focus:ring-2 focus:outline-hidden"
        :to="$router.resolve({ name: 'OrderView', params: { id: data.id } }).href"
        @click="context.context.handleClose"
    >
        <SvgIcon
            name="system-user-filled"
            class="text-muval-gray-4 size-10 shrink-0"
        />
        <div class="flex w-full max-w-32 flex-col">
            <span class="posthog-sensitive text-muval-gray-1 truncate font-medium"
                >{{ data.customer_firstname }} {{ data.customer_lastname }}</span
            >
            <span class="text-muval-gray-2">#{{ data.ref }}</span>
        </div>
    </router-link>
</template>
<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const context = inject('context');
</script>
